import { getRequestTransportErrorMessage } from '#/utils/requestError';

const MESSAGES = {
  INSPECTION_CODE_INVALID: '代碼格式必須為大寫英數字或底線',
  INSPECTION_CONDITION_ITEMS_REQUIRED: '請至少新增一項條件',
  INSPECTION_CONDITION_ITEM_REQUIRED: '條件項目不可為空',
  INSPECTION_CONDITION_ITEM_CODE_DUPLICATED: '條件代碼不可重複',
  INSPECTION_CONDITION_SEQUENCE_INVALID: '條件順序不可重複或無效',
  INSPECTION_CONDITION_DATA_TYPE_REQUIRED: '請選擇資料型別',
  INSPECTION_CONDITION_REQUIRED_REQUIRED: '請標示條件是否必填',
  INSPECTION_KIND_CODE_IMMUTABLE: '種類代碼不可修改',
  INSPECTION_CONDITION_DATA_TYPE_IMMUTABLE: '既有條件的資料型別不可修改',
  INSPECTION_CONDITION_CRITERIA_INVALID: '合格條件與資料型別不符',
  INSPECTION_CONDITION_UNIT_INVALID: '只有數值條件可以填單位',
  INSPECTION_KIND_CODE_DUPLICATED: '種類代碼已存在',
  RESOURCE_VERSION_CONFLICT: '資料已被他人修改，請重新載入後再儲存',
  INSPECTION_TEXT_REQUIRED: '請填寫必填文字',
  INSPECTION_KIND_NOT_FOUND: '找不到檢測種類',
  INSPECTION_CONDITION_REVISION_NOT_FOUND: '找不到這個歷史版本',
  UPDATED_AT_REQUIRED: '缺少更新時間，請重新載入後再試',
};

const FIELD_BY_CODE = {
  INSPECTION_CODE_INVALID: 'code',
  INSPECTION_CONDITION_ITEMS_REQUIRED: 'items',
  INSPECTION_CONDITION_ITEM_REQUIRED: 'items',
  INSPECTION_CONDITION_ITEM_CODE_DUPLICATED: 'items',
  INSPECTION_CONDITION_SEQUENCE_INVALID: 'items',
  INSPECTION_CONDITION_DATA_TYPE_REQUIRED: 'items',
  INSPECTION_CONDITION_REQUIRED_REQUIRED: 'items',
  INSPECTION_KIND_CODE_IMMUTABLE: 'code',
  INSPECTION_CONDITION_DATA_TYPE_IMMUTABLE: 'items',
  INSPECTION_CONDITION_CRITERIA_INVALID: 'items',
  INSPECTION_CONDITION_UNIT_INVALID: 'items',
  INSPECTION_KIND_CODE_DUPLICATED: 'code',
  RESOURCE_VERSION_CONFLICT: 'code',
  INSPECTION_TEXT_REQUIRED: 'name',
  UPDATED_AT_REQUIRED: 'code',
};

function pathFromField(field, fallback) {
  if (field === 'code' || field === 'name') {
    return field;
  }
  if (typeof field === 'string' && field.startsWith('items')) {
    return 'items';
  }
  return fallback;
}

export function getInspectionKindApiErrorMessage(error, fallback = '操作失敗，請稍後再試') {
  const transportMessage = getRequestTransportErrorMessage(error);
  if (transportMessage) {
    return transportMessage;
  }

  const data = error?.response?.data;
  const code = data?.code;
  if (MESSAGES[code]) {
    return data?.message || MESSAGES[code];
  }
  return data?.message || fallback;
}

export function getInspectionKindFieldIssue(error) {
  const data = error?.response?.data;
  const code = data?.code;
  const fallbackPath = FIELD_BY_CODE[code];
  if (!fallbackPath) {
    return null;
  }

  return {
    path: pathFromField(data?.field, fallbackPath),
    message: getInspectionKindApiErrorMessage(error),
  };
}

export function isInspectionKindReloadConflict(error) {
  const status = error?.response?.status;
  const code = error?.response?.data?.code;
  return status === 409
    || code === 'RESOURCE_VERSION_CONFLICT'
    || code === 'INSPECTION_KIND_CODE_DUPLICATED';
}
